import React from "react";
import ResendRegistrationLink from "../components/PartnerManagement/PartnerMenu/ResendRegistrationLink";
import ChangeRM from "../components/PartnerManagement/PartnerMenu/ChangeRM";
import ChangeSignatory from "../components/PartnerManagement/PartnerMenu/ChangeSignatory";
import DeactivatePartner from "../components/PartnerManagement/PartnerMenu/DeactivatePartner";
import ViewEditDetails from "../components/PartnerManagement/PartnerMenu/ViewEditDetails";
import ApprovedPartner from "../components/PartnerManagement/PartnerMenu/ApprovedPartner";
import ViewDetails from "../components/PartnerManagement/PartnerMenu/ViewDetails";
import ActivateUser from "../components/AccessManagement/UserMenu/ActivateUser";
import RendWelcomeMail from "../components/AccessManagement/UserMenu/ResendelcomeMail";
import DeactivateUser from "../components/AccessManagement/UserMenu/DeactivateUser";
import ViewUserEditDetails from "../components/AccessManagement/UserMenu/ViewUserEditDetails";
import ChangeThreshold from "../components/PartnerManagement/PartnerMenu/ChangeThreshold";
import ViewLeadMenu from "../components/leadMangement/menu/ViewLeadMenu";
import ModifyBankDetails from "../components/PartnerManagement/PartnerMenu/ModifyBankDetails";
import ModifyBankMenu from "../components/PartnerManagement/PartnerMenu/ModifyBankMenu";

const Components = {
  ViewDetails: ViewDetails,
  ViewEditDetails: ViewEditDetails,
  ResendRegistrationLink: ResendRegistrationLink,
  ChangeRM: ChangeRM,
  ChangeSignatoryUser: ChangeSignatory,
  DeactivatePartner: DeactivatePartner,
  ActivatePartner: ApprovedPartner,
  ViewUserEditDetails: ViewUserEditDetails,
  ActivateUser: ActivateUser,
  ResendWelcomeMail: RendWelcomeMail,
  DeactivateUser: DeactivateUser,
  ChangeThreshold: ChangeThreshold,
  ViewLeadDetails: ViewLeadMenu,
  ModifyBankDetails: ModifyBankMenu,
};

export default (
  block,
  hide,
  index,
  row,
  setPartnerRefresh,
  partnerRefresh,
  callBackAPI
) => {
  if (typeof Components[block.component] !== "undefined") {
    return React.createElement(Components[block.component], {
      key: block._uid,
      block: block,
      hide: hide,
      index: index,
      row: row,
      partnerRefresh: partnerRefresh,
      setPartnerRefresh: setPartnerRefresh,
      callBackAPI: callBackAPI,
    });
  }
  return React.createElement(() => <div> {block.component} </div>, {
    key: block._uid,
  });
};
